<template>
  <BaseForm
    :title="formTitle"
    :formData="producerAreaRateData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue'; // Ensure the path is correct
import axios from 'axios';

export default {
  components: {
    BaseForm
  },
  props: {
    producerAreaRateId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      producerAreaRateData: {
        producer_area_id: '',
        crop_id: '',
        name: '',
        ton_rate: '',
        mile_rate: '',
        min_miles: ''
      },
      fields: [
        { model: 'producer_area_id', label: 'Producer Area', required: true, type: 'select', optionsUrl: '/api/v1/producer_area/producer-areas/', labelField: 'name' },
        { model: 'crop_id', label: 'Crop', required: true, type: 'select', optionsUrl: '/api/v1/crop/crops/', labelField: 'crop' },
        { model: 'name', label: 'Name', required: true, type: 'text' },
        { model: 'ton_rate', label: 'Ton Rate ($/ton)', required: true, type: 'number' },
        { model: 'mile_rate', label: 'Mile Rate ($/mile)', required: true, type: 'number' },
        { model: 'min_miles', label: 'Minimum Miles', required: true, type: 'number' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.producerAreaRateId ? `Edit Producer Area Rate` : 'Add Producer Area Rate';
    },
    submitUrl() {
      return this.producerAreaRateId ? `/api/v1/producer_area_rate/producer-area-rates/${this.producerAreaRateId}/` : '/api/v1/producer_area_rate/producer-area-rates/';
    },
    method() {
      return this.producerAreaRateId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.producerAreaRateId) {
      this.loadProducerAreaRateData();
    }
  },
  methods: {
    loadProducerAreaRateData() {
      axios.get(`/api/v1/producer_area_rate/producer-area-rates/${this.producerAreaRateId}/`).then(response => {
        this.producerAreaRateData = {...response.data, producer_area_id: response.data.producer_area_id.id, crop_id: response.data.crop_id.id }; // Adjust for nested object ids
      }).catch(console.error);
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Producer Area Rate saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      console.error(error);
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the producer area rate!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>

